import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ChannelBaseDataObject } from 'models/service';

// eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
export const getChannels = async (params: { limit?: number; offset?: number; organization_id?: string }) =>
  apiClient.get<ChannelBaseDataObject[], ApiClientResponse<ChannelBaseDataObject[]>>(routes.channels.find, {
    params,
  });
